/* Kylea - barra "carrello riservato": il timer parte alla prima apertura del carrello,
   resta salvato nel browser e, a zero, lascia solo il testo finale. */
(() => {
  if (customElements.get('ky-cart-timer')) return;
  const KEY = 'ky_cart_reserved_v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } };
  const write = (data) => { try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {} };
  const format = (ms) => {
    const total = Math.max(0, Math.ceil(ms / 1000));
    return Math.floor(total / 60) + ':' + String(total % 60).padStart(2, '0');
  };

  class KyCartTimer extends HTMLElement {
    connectedCallback() {
      this.minutes = Math.min(30, Math.max(1, parseInt(this.dataset.minutes, 10) || 5));
      const data = read();
      if (data && data.min === this.minutes && (data.ended || data.end <= Date.now())) return this.finish();
      if (data && data.min === this.minutes) return this.run(data.end);

      const drawer = this.closest('cart-drawer');
      if (!drawer || drawer.hasAttribute('open')) return this.start();
      this.observer = new MutationObserver(() => {
        if (!drawer.hasAttribute('open')) return;
        this.observer.disconnect();
        this.start();
      });
      this.observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearInterval(this.interval);
    }

    start() {
      const data = read();
      if (data && data.min === this.minutes) {
        if (data.ended || data.end <= Date.now()) return this.finish();
        return this.run(data.end);
      }
      const end = Date.now() + this.minutes * 60000;
      write({ end, min: this.minutes });
      this.run(end);
    }

    run(end) {
      const clock = this.querySelector('[data-ky-timer-clock]');
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) {
          clearInterval(this.interval);
          return this.finish();
        }
        if (clock) clock.textContent = format(left);
      };
      clearInterval(this.interval);
      tick();
      this.interval = setInterval(tick, 1000);
    }

    finish() {
      const data = read() || {};
      if (!data.ended) write({ end: data.end || Date.now(), min: this.minutes, ended: true });
      const running = this.querySelector('[data-ky-timer-running]');
      const ended = this.querySelector('[data-ky-timer-ended]');
      if (running) running.hidden = true;
      if (ended) ended.hidden = false;
    }
  }

  customElements.define('ky-cart-timer', KyCartTimer);
})();
